import React from "react";
import Icon from "../Icon";
import "./styles.css";

export default props => {
  return (
    <div className="content-header-holder">
      {props.icon && <Icon className="content-header-icon" {...props} />}
      <b className="content-header-text">{props.text}</b>
    </div>
  );
};
